import { BankLogo } from "@bokio/bank/src/components/BankLogo/BankLogo";
import { formatAmountWithCurrency, formatDate } from "@bokio/shared/utils/format";
import { paymentAccountLabel } from "@bokio/shared/utils/paymentAccountHelper";

import type * as m from "@bokio/mobile-web-shared/core/model/model";
import type { FC } from "react";

import * as styles from "./bankRowMatchItem.scss";

export interface BankRowMatchItemProps {
	date: Date;
	text: string;
	amount: m.Bokio.Common.Contract.AmountWithCurrency;
	bookkeepingAccount: number;
	accountName?: string;
	bank?: m.Bokio.Bank.Contract.Dtos.BankForView;
}

export const BankRowMatchItem: FC<BankRowMatchItemProps> = ({
	date,
	text,
	amount,
	bookkeepingAccount,
	accountName,
	bank,
}) => {
	return (
		<div className={styles.container}>
			{bank && (
				<div className={styles.logo}>
					<BankLogo bank={bank} size="small" hideName />
				</div>
			)}
			<div className={styles.content}>{text}</div>
			<div className={styles.amount}>{formatAmountWithCurrency(amount)}</div>
			<div className={styles.date}>{formatDate(date)}</div>
			<div className={styles.account}>{paymentAccountLabel(bookkeepingAccount, accountName)}</div>
		</div>
	);
};
